<template>
  <div class="form-group bg-light-2 p-4 shadow-lg mt-5">
    <h4>Otros datos</h4>
    <hr />
    <div class="row">
      <div class="col-md-4">
        <label>
          <span class="text-danger">*</span>
          Tipo de moneda
        </label>
        <select
          class="form-control"
          :value="currency"
          @change="handleChangeCurrency"
        >
          <option
            v-for="change in changes"
            :key="'change-' + change.currency"
            :value="change.currency"
            :selected="change.currency == currency"
          >
            {{ change.currency }}
          </option>
        </select>
      </div>
      <div class="col-md-4">
        <label>
          <span class="text-danger">*</span>
          Precio del {{ kind }}
        </label>
        <input
          type="number"
          class="form-control"
          :placeholder="'Precio del ' + kind"
          :value="price"
          @keyup="(e) => handleChangePrice(e)"
        />
      </div>
      <div class="col-md-4">
        <label>Precio final publicado en Sacoin (SC$)</label>
        <input
          type="number"
          class="form-control"
          :placeholder="'Precio del ' + kind"
          disabled
          v-model="publishedPrice"
        />
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-md-4">
        <label>Comisión por venta (%)</label>
        <input
          type="text"
          class="form-control"
          :placeholder="'Precio del ' + kind"
          disabled
          :value="comision + '%'"
        />
      </div>
      <div class="col-md-4">
        <label>Valor a recibir (${{ currency }})</label>
        <input
          type="text"
          class="form-control"
          :placeholder="'Precio del ' + kind"
          disabled
          :value="receiveAmountWithCurrencySelected"
        />
      </div>
      <div class="col-md-4">
        <label>Valor a recibir ($SC)</label>
        <input
          type="number"
          class="form-control"
          :placeholder="'Precio del ' + kind"
          disabled
          :value="receiveAmount"
        />
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-md-6" v-if="kind == 'producto'">
        <label
          ><span class="text-danger">*</span> Cantidad en inventario
        </label>
        <input
          type="number"
          placeholder="Cantidad"
          class="form-control"
          :value="amount"
          @change="handleChangeAmount"
        />
      </div>
      <div class="col-md-6">
        <label> <span class="text-danger">*</span> Descuento </label>
        <input
          type="number"
          class="form-control"
          placeholder="Porcentaje descuento"
          min="0"
          max="100"
          @change="handleChangeDiscount"
          :value="discount"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { LC } from "../../tools/exchange";
export default {
  name: "PricePublication",
  props: {
    currency: {
      type: String,
      default: "MXN",
    },
    price: {
      type: Number,
      default: 0,
    },
    discount: {
      type: Number,
      default: 0,
    },
    comision: {
      type: Number,
      default: 0,
    },
    amount: {
      type: Number,
      default: 1,
    },
    kind: {
      type: String,
      default: "producto",
    },
  },
  data() {
    return {
      localCurrency: null,
    };
  },
  async created() {
    LC.new().then((localCurrency) => {
      this.localCurrency = localCurrency;
    });
  },
  methods: {
    handleChangePrice(e) {
      this.$emit("handleChangePrice", Number(e.target.value));
    },
    handleChangeCurrency(e) {
      this.$emit("handleChangeCurrency", e.target.value);
    },
    handleChangeAmount(e) {
      this.$emit("handleChangeAmount", Number(e.target.value));
    },
    handleChangeDiscount(e) {
      this.$emit("handleChangeDiscount", Number(e.target.value));
    },
  },
  computed: {
    changes() {
      if (!this.localCurrency) return [];
      return this.localCurrency.getList();
    },
    publishedPrice() {
      const discountP = 1 - this.discount / 100;
      if (this.localCurrency)
        return this.localCurrency
          .localToSC({ price: this.price * discountP, currency: this.currency })
          .toFixed(2);
      return 0;
    },
    receiveAmountWithCurrencySelected() {
      const commisionP = 1 - this.comision / 100;
      const discountP = 1 - this.discount / 100;
      return (this.price * discountP * commisionP).toFixed(2);
    },
    receiveAmount() {
      if (!this.localCurrency) return 0;

      const commisionP = 1 - this.comision / 100;
      const discountP = 1 - this.discount / 100;
      return (
        this.localCurrency.localToSC({
          price: this.price * discountP,
          currency: this.currency,
        }) * commisionP
      ).toFixed(2);
    },
  },
};
</script>
